export var internalCodeTranslationKeys = {
  '105': 'emptyMandatoryProperty',
  '322': 'disabledDuringMaintenance',
  '157': 'blockedForLoginUser',
  '119': 'invalidPropertyLength',
  '106': 'invalidPropertyFormat',
  '160': 'customerNotFound',
  '177': 'phoneNotFound',
  '178': 'emailNotFound',
  '107': 'emptyMandatoryEmailAndPhone',
  '306': 'customerHasInactiveAccount',
  '158': 'terminatedOrNotExistingCustomer',
  '140': 'emptyMandatoryNotificationChannel',
  '179': 'externalAccountAlreadyConnected',
  '102': 'invalidPassword',
  '101': 'invalidPasswordFormat',
  '100': 'invalidResetToken',
  '423': 'accountLockedDueToMultipleInvalidLogin'
};